import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    currentTimezone: String,
    url: String
  }

  connect() {
    this.detectAndSync()
  }

  detectAndSync() {
    try {
      const detectedTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
      if (!detectedTimezone) return

      // Skip if server already has the correct timezone
      if (this.currentTimezoneValue === detectedTimezone) return

      fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('[name="csrf-token"]').content,
          "Accept": "application/json"
        },
        body: JSON.stringify({ timezone: detectedTimezone })
      })
    } catch (e) {
      // Silently fail -- timezone is a nice-to-have
      console.debug("Timezone detection failed:", e)
    }
  }
}
